import React from 'react'
import { Link } from 'react-router-dom'
import { FiArrowUpRight, FiMapPin, FiPhone } from 'react-icons/fi'
import { FaInstagram } from 'react-icons/fa'
import { useStudio } from '../context/StudioContext'

export default function Footer() {
  const currentYear = new Date().getFullYear()
  const { studio } = useStudio()

  return (
    <footer className="border-t border-stone-200/70 bg-stone-950 text-stone-100">
      <div className="section-shell py-16">
        <div className="grid gap-10 lg:grid-cols-[1.4fr_0.8fr_1fr]">
          <div>
            <p className="eyebrow text-stone-400">Maya Nails Spa</p>
            <h2 className="mt-4 font-heading text-4xl text-stone-50">
              Nails, beauty, and laser care with a Tampa studio identity.
            </h2>
            <p className="mt-4 max-w-2xl text-sm leading-7 text-stone-300">
              {studio?.heroDescription || 'Boutique nail care, beauty detail, and laser-focused service with bilingual support.'}
            </p>
            <div className="mt-6 flex flex-wrap gap-3">
              {(studio?.bioLines || []).slice(0, 4).map((line) => (
                <span key={line} className="rounded-full border border-white/15 px-4 py-2 text-xs uppercase tracking-[0.18em] text-stone-200">
                  {line}
                </span>
              ))}
            </div>
          </div>

          <div>
            <p className="eyebrow text-stone-400">Explore</p>
            <div className="mt-5 space-y-3 text-sm">
              <Link to="/" className="footer-link">Home</Link>
              <Link to="/services" className="footer-link">Services</Link>
              <Link to="/gallery" className="footer-link">Gallery</Link>
              <Link to="/team" className="footer-link">Studio</Link>
              <Link to="/booking" className="footer-link">Booking</Link>
              <Link to="/contact" className="footer-link">Contact</Link>
            </div>
          </div>

          <div>
            <p className="eyebrow text-stone-400">Contact</p>
            <div className="mt-5 space-y-4 text-sm text-stone-300">
              <a href={studio ? `tel:+1${studio.phone}` : 'tel:+18138503700'} className="footer-link flex items-center gap-3">
                <FiPhone className="text-rose-300" />
                <span>{studio?.phoneDisplay || '(813) 850-3700'}</span>
              </a>
              <div className="flex items-center gap-3">
                <FiMapPin className="text-rose-300" />
                <span>{studio?.city || 'Tampa, Florida'}</span>
              </div>
              <a
                href={studio?.instagramUrl || 'https://www.instagram.com/maya__nails/'}
                target="_blank"
                rel="noopener noreferrer"
                className="footer-link flex items-center gap-3"
              >
                <FaInstagram className="text-rose-300" />
                <span>{studio?.handle || '@maya__nails'}</span>
                <FiArrowUpRight />
              </a>
            </div>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-3 border-t border-white/10 pt-6 text-xs uppercase tracking-[0.18em] text-stone-500 sm:flex-row sm:items-center sm:justify-between">
          <p>&copy; {currentYear} Maya Nails Spa</p>
          <p>Quality / Safety / Results</p>
        </div>
      </div>
    </footer>
  )
}
